<template>
    <div class="detail__list">
        <div class="detail__entry" v-for="entry in entries">
            <span>{{ entry }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AddressSummary',
    props: {
        entries: { type: Object, required: true },
    },
};
</script>

<style></style>
